var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenBolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 70,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6572 32.1487C72.169 29.9261 75.6447 30.9961 75.6447 33.6842V59.1888C75.6447 60.6943 76.8635 61.9157 78.369 61.9189L95.9491 61.9566C98.1385 61.9613 99.432 64.4121 98.2005 66.2224L68.2647 110.227C66.7528 112.45 63.2773 111.379 63.2773 108.691V83.1858C63.2773 81.6803 62.0585 80.4589 60.553 80.4557L42.978 80.418C40.7886 80.4133 39.4951 77.9627 40.7264 76.1524L70.6572 32.1487Z",
    fill: "#0C8B6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenBolt);
export default __webpack_public_path__ + "static/media/green-bolt.4981bac3d6663982f7834066ed232388.svg";
export { ForwardRef as ReactComponent };